import { render, staticRenderFns } from "./InterfaceTranslation.vue?vue&type=template&id=547a3566"
import script from "./InterfaceTranslation.vue?vue&type=script&lang=js"
export * from "./InterfaceTranslation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports